import { PerformanceSectionProps } from "../types/common";
import DesktopView from "./desktop-view";
import MobileView from "./mobile-view";

export default function DefaultView({ data }: { data: PerformanceSectionProps }) {
  return (
    <>
      <DesktopView data={data} />
      <MobileView data={data} />
    </>
  );
}
